import { CfDataGridCard } from './CfDataGridCard';
import { CfDataGridSkeletonCard } from './CfDataGridSkeletonCard';
import { CfDataGridCardCommonProps } from './common';

export interface CfDataGridCardByItemIdProps<TItem, TAppState> extends CfDataGridCardCommonProps<TItem> {
  itemId: string | undefined;
  after: boolean | undefined;
  itemSelector: (itemId: string, store: TAppState) => TItem | undefined;
  useSelector: (itemSelector: (state: TAppState) => TItem | undefined) => TItem | undefined;
}

export function CfDataGridCardByItemId<TItem, TAppState>(
  props: CfDataGridCardByItemIdProps<TItem, TAppState>
): JSX.Element {
  const itemId = props.itemId ?? '';

  const item: TItem | undefined = props.useSelector((state) => props.itemSelector(itemId, state));

  if (!itemId) {
    return <CfDataGridSkeletonCard cardViewDefinition={props.cardViewDefinition} orientation={props.orientation} />;
  }

  if (item) {
    const bodyCardRowProps =
      typeof props.cardViewDefinition.bodyCardRowProps === 'function'
        ? props.cardViewDefinition.bodyCardRowProps(item, props.index, props.after)
        : props.cardViewDefinition.bodyCardRowProps;

    return (
      <CfDataGridCard
        item={item}
        onItemClicked={props.onItemClicked}
        cardViewDefinition={props.cardViewDefinition}
        index={props.index}
        cursorStyle={props.cursorStyle}
        hoverStyle={props.hoverStyle}
        setNavigableElement={props.setNavigableElement}
        recomputeRowHeights={props.recomputeRowHeights}
        recomputeRowHeight={props.recomputeRowHeight}
        cardSx={bodyCardRowProps?.sx}
        gridItemSx={bodyCardRowProps?.gridItemSx}
        orientation={props.orientation}
        after={props.after}
      />
    );
  }

  return <></>;
}
